import React, {useContext, useEffect, useState} from "react";
import {observer} from "mobx-react";
import {StoreContext} from "../../store.context";



type Props = {
    children: React.ReactNode,
    onDenied?: () => void
}

const FoAccessUtil: React.FC<Props> = observer(({  onDenied, children}): any => {

    const {
        appStore: {
            accessStore: {
                hasFoAccess
            },
            authStore: {
                account
            }
        },
    } = useContext(StoreContext);



    const [accessGranted, setAccessGranted] = useState<boolean>(false);

    useEffect(() => {
      if (hasFoAccess()) {
            setAccessGranted(true);
        } else {
            setAccessGranted(false);
        }
    }, [account, hasFoAccess]);

    if (!accessGranted) return (onDenied && onDenied()) ?? null;

    return <>{children}</>;
});

export default FoAccessUtil;